export enum Status {
  ACTIVE = "active",
  ERROR = "error",
  NOT_VISITED = "notVisited",
  VISITED = "visited",
}

export type StatusType = `${Status}`;

export type StepDetails<T> = {
  id: T;
  label: string;
  description?: string;
  status: Status;
  hasError?: boolean;
};

export enum CampaignSimulationStepsIds {
  TRIGGER = "trigger",
  MEMBER = "member",
  REFERRED_MEMBER = "referrerMember",
  TRANSACTION = "transaction",
  EVENT = "event",
  SUMMARY = "summary",
}

export type CampaignSimulationStepsUnion = `${CampaignSimulationStepsIds}`;

export enum AchievementStepsIds {
  ACHIEVEMENT_INFO = "achievementInfo",
  RULES = "rules",
  SUMMARY = "summary",
}

export type AchievementStepsUnion = `${AchievementStepsIds}`;
